import { FormTemplate } from '@src/core';

const Collect2Form: FormTemplate = {
  title: 'Questionário Puérpera',
  subtitle: 'Questionário 2: de 8 a 10 dias pós-parto',
  initialMessage:
    'Olá, tudo bem? <br/><br/> Primeiramente, obrigado por estar dedicando um tempo para nos ajudar com a pesquisa! <br/><br/>A seguir, faremos algumas perguntas sobre seu processo de recuperação neste período de <b>8 a 10 dias pós parto</b>.Por favor, selecione as respostas que mais fielmente representam seu estado atual, especialmente em relação à recuperação na área com pontos onde você foi suturada.<br/><br/>Durante as questões, você notará que mencionaremos a palavra "DOR" algumas vezes. Sempre que isso ocorre, estamos nos referindo a qualquer tipo de desconforto ou sensação incômoda associada aos pontos no períneo/vagina.<br/><br/>Vamos lá?',
  endedMessage:
    'Muito obrigado por ter respondido nossa pesquisa do projeto PEARLS! 🤩 <br/><br/>Sua ajuda faz toda a diferença para nós e para muitas outras mulheres.',
  step: {
    title: 'Avaliação',
    questions: {
      question01: {
        sequence: 1,
        type: 'radio',
        label: '1. Como você diria que está se sentindo fisicamente?',
        options: ['Muito Bem', 'Razoavelmente bem', 'Não muito bem', 'Nada bem'],
        validator: {
          dataType: 'string',
          required: true,
        },
        fullWidth: true,
      },

      question02: {
        sequence: 2,
        type: 'radio',
        label:
          '2. Você precisou tomar algum analgésico para a dor ou desconforto da área onde foi suturada/com pontos?',
        options: ['Sim', 'Não'],
        validator: {
          dataType: 'string',
          required: true,
        },
        fullWidth: true,
      },

      question03: {
        sequence: 3,
        type: 'checkbox',
        label:
          '3. Nas últimas 24 horas, você precisou fazer uso de algum método para aliviar dor ou desconforto dos pontos?',
        helperText: '(marque todas as opções aplicáveis)',
        options: [
          'Precisei procurar ajuda em um hospital',
          'Utilizei métodos naturais que foram suficientes',
          'Utilizei analgésico que tenho em casa',
        ],
        validator: {
          dataType: 'array',
          required: true,
          min: { value: 1, errorMessage: 'Selecione pelo menos UMA opção' },
        },
        fullWidth: true,
      },

      question04: {
        sequence: 4,
        type: 'radio',
        label: '4. Como você descreveria a intensidade da dor ou desconforto?',
        options: ['Nenhuma', 'Leve', 'Moderado', 'Grave'],
        validator: {
          dataType: 'string',
          required: true,
        },
        fullWidth: true,
      },

      question05: {
        sequence: 5,
        type: 'radio',
        label: '5. Se existe dor ou desconforto, qual a frequência?',
        options: ['Pouco frequente', 'Quase sempre', 'Sempre'],
        validator: {
          dataType: 'string',
          required: false,
        },
        fullWidth: true,
      },

      question06: {
        sequence: 6,
        layout: '4-column',
        type: 'checkbox',
        label:
          '6. Marque quantas palavras abaixo melhor descrevem a sensação de dor ou desconforto que você sentiu na área onde foi suturada/com pontos nas últimas 24 horas.',
        options: [
          'ardente',
          'beliscando',
          'coçando',
          'cortante',
          'dor aguda',
          'dor contínua',
          'dor forte',
          'dor leve',
          'dor moderada',
          'estirando/repuxando',
          'formigando',
          'pinicando',
          'pontada',
          'torturante',
          'outros',
        ],
        validator: {
          dataType: 'array',
          required: false,
          min: { value: 0 },
        },
        fullWidth: true,
        requestDetail: {
          label: 'Para "outros", por favor descreva:',
          conditions: [{ condition: 'outros' }],
        },
      },

      question07: {
        sequence: 7,
        type: 'radio-matrix',
        label:
          '7. Nas últimas 24 horas, quanta dor ou desconforto você sentiu na área onde foi suturada/com pontos ao fazer as seguintes atividades:',
        helperText: '',
        options: ['Nenhum', 'Leve', 'Moderado', 'Grave'],
        criteria: [
          'Alimentar seu bebê',
          'Andar certa de 100m',
          'Ficar em pé',
          'Sentar-se',
          'Deitada na cama',
          'Ao subir e descer da cama',
          'Ao se curvar ou abaixar',
          'Ao trocar o bebê',
          'Carregar seu bebê',
          'Fazer trabalho doméstico',
          'Ao urinar',
          'Ao evacuar',
        ],
        validator: {
          dataType: 'string',
          required: true,
        },
        fullWidth: true,
      },

      question08: {
        sequence: 8,
        type: 'checkbox',
        label: '8. Você:',
        helperText: '(marque todas as opções aplicáveis)',
        options: [
          'Olhou para o seu períneo/vagina usando um espelho',
          'Sentiu o períneo/vagina com a mão',
          'Pediu para um familiar olhar seu períneo/vagina',
          'Não olhou ou sentiu o períneo/vagina',
        ],
        validator: {
          dataType: 'array',
          required: true,
          min: { value: 1, errorMessage: 'Selecione pelo menos UMA opção' },
        },
        fullWidth: true,
      },
      question09: {
        sequence: 9,
        type: 'radio',
        label: '9. Depois de olhar a área onde você foi suturada/com pontos:',
        options: [
          'Não conseguiu ver ou sentir',
          'Parecia ou teve a sensação de estar PIOR do que você pensava',
          'Parecia ou teve a sensação de estar MELHOR do que você pensava',
        ],
        validator: {
          dataType: 'string',
          required: true,
        },
        fullWidth: true,
      },

      question10: {
        sequence: 10,
        type: 'radio',
        label: '10. Você acha que seu períneo/vagina está cicatrizando? Sente-se "de volta ao normal"?',
        options: [
          'Sinto que meu períneo/vagina está cicatrizado, está de volta ao normal',
          'Sinto que meu períneo/vagina está cicatrizando bem, está quase de volta ao normal',
          'Sinto que meu períneo/vagina cicatrizou, porém, ficou com menor elasticidade e não está de volta ao normal',
          'Sinto que meu períneo/vagina está cicatrizando muito mal, longe de voltar ao normal',
        ],
        validator: {
          dataType: 'string',
          required: true,
        },
        fullWidth: true,
      },

      question11: {
        sequence: 11,
        type: 'radio',
        label: '11. Após a alta, você teve alguma infecção na área onde foi suturada/com pontos?',
        options: [
          'Não tive infecção',
          'Sim, precisei ir ao hospital e eles refizeram os pontos',
          'Sim, a infecção foi confirmada por um exame com o cotonete passado no corte',
          'Acho que sim, utilizei métodos naturais em casa que foram suficientes',
          'Sim, fui ao hospital e precisei apenas utilizar antibiótico',
        ],
        validator: {
          dataType: 'string',
          required: true,
        },
        fullWidth: true,
        requestDetail: {
          label:
            'Se a resposta foi "Sim, precisei ir ao hospital e eles refizeram os pontos", informe com quantos dias',
          conditions: [{ condition: 'Sim, precisei ir ao hospital e eles refizeram os pontos' }],
        },
      },

      question12: {
        sequence: 12,
        type: 'checkbox',
        label: '12. Você experimentou algum dos seguintes sintomas AO URINAR após a alta hospitalar?',
        helperText: '(marque todas as opções aplicáveis)',
        options: [
          'Não sentiu nenhum desses sintomas desde o nascimento do seu bebê',
          'Vazamento de urina ao tossir ou espirrar (incontinência de estresse)',
          'Urina com frequência durante o dia (mais de 7 vezes)',
          'Urina com frequência durante a noite (mais de 2 vezes)',
          'Não conseguiu esperar até chegar ao banheiro para urinar',
          'Ficou com incontinência urinária (sem saber que precisava urinar)',
        ],
        validator: {
          dataType: 'array',
          required: true,
          min: { value: 1, errorMessage: 'Selecione pelo menos UMA opção' },
        },
        fullWidth: true,
      },

      question13: {
        sequence: 13,
        type: 'checkbox',
        label: '13. Você experimentou algum dos seguintes sintomas AO EVACUAR após a alta hospitalar?',
        helperText: '(marque todas as opções aplicáveis)',
        options: [
          'Ciente de que precisa evacuar, mas incapaz de esperar até chegar ao banheiro',
          'Não sentiu vontade de evacuar, resultando em incontinência de fezes',
          'Presenciou sujeira ou manchas em sua roupa íntima com evacuações',
          'Sentiu dor ao evacuar',
          'Incapaz de controlar a eliminação de gases/pum pelo ânus',
          'Não experimentou nenhum sintoma',
        ],
        validator: {
          dataType: 'array',
          required: true,
          min: { value: 1, errorMessage: 'Selecione pelo menos UMA opção' },
        },
        fullWidth: true,
      },
    },
  },
};

export { Collect2Form };
